module.exports = __webpack_public_path__ + "assets/casualsuperman.ae943355.png";